export default ({ request }) => ({
  // /Player/SearchByName/:nameStart/:active
  playerSearchByName: ({ name, active = true }) =>
    request(`Player/SearchByName/${name}/${Number(!!active)}`),

  playerSearchByPosition: ({ position, pageSize = 100, page = 1 }) =>
    request(`Player/SearchByPosition/${position}/${pageSize}/${page}`),

  playerTeamRoster: ({ teamId }) =>
    request(`Team/Roster/${teamId}`),

  playerDescription: ({ id }) =>
    request(`Player/${id}`),

  playerStatsSummary: ({ id, formula, year }) =>
    request(`Player/Stats/Summary/${id}/${formula}/${year}`),

  playerNews: ({ id, pageSize = 99999 }) =>
    request(`Player/News/${id}/${pageSize}`),

  playerStats: ({ id, formula }) =>
    request(`Player/Stats/${id}/${formula}`),

  playerGameLogs: ({ id, year, formula }) =>
    request(`Player/GameLog/${year}/${id}/${formula}`),

  playerStatsColMappings: () =>
    request('Stats/ToolPositionStatMap/player-page-stats'),

  playerGameLogsColMappings: () =>
    request('Stats/ToolPositionStatMap/game-log'),

});



// WEBPACK FOOTER //
// ./src/lib/api/players.js